function pluralDays(n) {
  const d = Math.abs(Math.floor(Number(n) || 0));
  if (d % 10 === 1 && d % 100 !== 11) return `${d} день`;
  if (d % 10 >= 2 && d % 10 <= 4 && (d % 100 < 10 || d % 100 >= 20)) return `${d} дня`;
  return `${d} дней`;
}

/**
 * Подпись центра выдачи / доставки для карточки товара.
 * @returns {string|null}
 */
export function getProductDeliveryCaption(product, branchAddressByKey = {}) {
  const av = product?.branchAvailability;
  if (!Array.isArray(av) || av.length === 0) return null;

  const resolveAddress = (branchId) => {
    const key = String(branchId || '').trim();
    if (!key) return null;
    return branchAddressByKey[key] || null;
  };

  const inStock = av.filter((a) => Number(a.deliveryDays) === 0);
  if (inStock.length > 0) {
    for (const row of inStock) {
      const address = resolveAddress(row.branchId);
      if (address) return `📍 ${address}`;
    }
  }

  const deliveryDays = av
    .map((a) => Number(a.deliveryDays))
    .filter((d) => Number.isFinite(d) && d > 0);

  if (deliveryDays.length === 0) return null;

  const minDays = Math.min(...deliveryDays);
  return `Под заказ, доставка от ${pluralDays(minDays)}`;
}

export { pluralDays };
